import { createRouter, createWebHashHistory } from 'vue-router'

import Users from '../pages/users.vue'
import Settings from '../pages/settings.vue'
import Advertisers from '../pages/Advertisers/index.vue'
import AdvertiserDetail from '../pages/Advertisers/detail.vue'
import AddAdvertisers from '../pages/Advertisers/addAdvertiser.vue';
import AddAffiliate from '../pages/Advertisers/addAffiliate.vue';
import Influencers from '../pages/influencers/index.vue';
import InfluencerDetail from '../pages/influencers/edit.vue';
import Commissions from '../pages/commissions/index.vue';
import InfluencerReports from '../pages/reports/index.vue';
import LinkTool from '../pages/linkTool.vue'
import LinksAnalytics from '../pages/LinksAnalytics'
import Payments from '../pages/payments/index.vue'
import PendingPaymentDetail from '../pages/payments/PendingPaymentDetail.vue'
import DmReceivedPaymentDetail from '../pages/payments/DmReceivedPaymentDetail.vue'

export default createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import('../pages/login.vue'),
      meta: {
        title: 'Sign in - In Rewards'
      }
    },
    {
      path: "/",
      name: "home",
      redirect: '/advertisers',
      component: () => import('../pages/index.vue'),
      children: [
        {
          path: "/404",
          name: "404",
          component: () => import('../pages/404.vue'),
          meta: {
            title: 'Not Found - In Rewards'
          }
        },
        {
          path: 'advertisers',
          name: 'Advertisers',
          component: Advertisers,
          meta: {
            title: 'Advertisers - In Rewards',
          }
        },
        {
          path: 'advertiser/new',
          name: 'Add Advertiser',
          component: AddAdvertisers,
          meta: {
            title: 'Add Advertiser - In Rewards',
          }
        },
        {
          path: 'advertiser/edit/:id',
          name: 'Edit Advertiser',
          component: AddAdvertisers,
          meta: {
            title: 'Edit Advertiser - In Rewards',
          }
        },
        {
          path: 'affiliate/new',
          name: 'Add AddAffiliate',
          component: AddAffiliate,
          meta: {
            title: 'Add Advertiser - In Rewards',
          }
        },
        {
          path: 'affiliate/edit/:id',
          name: 'Edit AddAffiliate',
          component: AddAffiliate,
          meta: {
            title: 'Edit Advertiser - In Rewards',
          }
        },
        {
          path: 'advertiser/detail/:id',
          component: AdvertiserDetail,
          meta: {
            title: 'Advertiser Detail - In Rewards',
          }
        },
        {
          path: 'settings',
          name: 'Settings',
          component: Settings,
          meta: {
            title: 'Settings - In Rewards'
          }
        },
        {
          path: 'users',
          name: 'Users',
          component: Users,
          meta: {
            title: 'Users - In Rewards',
          }
        },
        {
          path: 'influencers/:activeTab',
          name: 'Influencers',
          component: Influencers,
          meta: {
            title: 'Influencers - In Rewards',
          }
        },
        {
          path: 'influencer/edit/:id',
          name: 'Influencer Detail',
          component: InfluencerDetail,
          meta: {
            title: 'Influencer Detail - In Rewards',
          }
        },
        {

          path: 'linktool',
          name: 'Linktool',
          component: LinkTool,
          meta: {
            title: 'Link Tool - In Rewards'
          }
        },
        {
          path: 'reports',
          name: 'Reports',
          component: InfluencerReports,
          meta: {
            title: 'Reports - In Rewards'
          }
        },
        {
          path: 'commissions',
          name: 'Commissions',
          component: Commissions,
          meta: {
            title: 'Commissions - In Rewards'
          }
        },
        {
          path: 'payments/dm-received/:id',
          name: 'DM Received Payment Detail',
          component: DmReceivedPaymentDetail,
          meta: {
            title: 'DM Received Payment Detail - In Rewards',
          }
        },
        {
          path: 'payments/pending-payment/:id',
          name: 'Pending Payment Detail',
          component: PendingPaymentDetail,
          meta: {
            title: 'Pending Payment Detail - In Rewards',
          }
        },
        {
          path: 'links-analytics',
          name: 'Links Analytics',
          component: LinksAnalytics,
          meta: {
            title: 'Links Analytics - In Rewards'
          }
        },
        {
          path: 'payments/:type',
          name: 'Payments',
          component: Payments,
          meta: {
            title: 'Payments - In Rewards'
          }
        }
      ]
    },
  ],
})